module.exports = __webpack_public_path__ + "img/logo-pgj.572d3361.png";